import React from 'react';
import { Navigate } from 'react-router-dom';
import NavBar from '../components/Admin/NavBar/NavBar';
import { useAuth } from '../Contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { currentUser } = useAuth();

  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  return (
    <>
      <NavBar />
      {children}
    </>
  );
};

export default ProtectedRoute;
